import { ChevronLeft, ChevronRight } from "lucide-react";

function Pagination({ currentPage, totalPages, onPageChange }) {
  const pages = [];

  // Generate page numbers (show up to 3 pages)
  const maxPagesToShow = 3;
  const startPage = Math.max(
    1,
    Math.min(
      currentPage - Math.floor(maxPagesToShow / 2),
      totalPages - maxPagesToShow + 1
    )
  );
  const endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-6 mb-4">
      <button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className="flex items-center text-sm text-gray-400 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeft size={16} className="mr-1" />
        First Page
      </button>

      <div className="flex gap-1">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-8 h-8 flex items-center justify-center rounded ${
              currentPage === page
                ? "bg-[#FFCA20] text-black font-medium"
                : "bg-gray-800 text-white hover:bg-gray-700"
            }`}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="flex items-center text-sm text-gray-400 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Last Page
        <ChevronRight size={16} className="ml-1" />
      </button>
    </div>
  );
}

export default Pagination;
